export default __webpack_public_path__ + "assets/images/f8f64ae162a9bd0ea135af50aa7c2d1a.png";